
// component
import RouterView from '@/components/router-view.vue';

import MemberInfoCom from './member-info/member-info.vue';
import ResetPasswordCom from './reset-password/reset-password.vue';
import Resetsecondstep from './reset-secondstep/reset-secondstep.vue';
import ResetSuccess from './reset-success/reset-success.vue';
import ModifyMemberInfo from './modify-member-info/index.vue';

import ModifyLegalFirst from './modify-legal-info/modify-legal-first/index.vue';
import ModifyLegalSecond from './modify-legal-info/modify-legal-second/index.vue';
import ModifyLegalThird from './modify-legal-info/modify-legal-third/index.vue';

import BankAccountManageRouter from './bank-account-manage/routing.js';
export default [
  {
    path: 'member-info',
    name: 'memberInfo',
    component: MemberInfoCom,
    meta: {
      title: '会员信息',
      breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'reset-password',
    name: 'resetPassword',
    component: ResetPasswordCom,
    meta: {
      title: '验证身份',
      breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'reset-secondstep',
    name: 'resetsecondstep',
    component: Resetsecondstep,
    meta: {
      title: '重置密码',
      breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'reset-success',
    name: 'resetSuccess',
    component: ResetSuccess,
    meta: {
      title: '重置成功',
      breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'modify-member-info',
    name: 'modifyMemberInfo',
    component: ModifyMemberInfo,
    meta: {
      title: '会员信息变更',
      breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'modify-legal-first',
    name: 'modifyLegalFirst',
    component: ModifyLegalFirst,
    meta: {
      title: '法定代表人变更',
      breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'modify-legal-second',
    name: 'modifyLegalSecond',
    component: ModifyLegalSecond,
    meta: {
      title: '业务审批员审批',
      breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'modify-legal-third',
    name: 'modifyLegalThird',
    component: ModifyLegalThird,
    meta: {
      title: '变更后法人验证',
      breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'bank-account-manage',
    name: 'bankAccountManage',
    component: RouterView,
    redirect: '/person-center/account-info/bank-account-manage/list',
    meta: {
      title: '银行账户管理',
      breadCrumbShowIndexArr: [1]
    },
    children: BankAccountManageRouter
  }
];
